import { call, put, takeLatest } from 'redux-saga/effects';
import { companiesListSuccess, companiesListRequest, companiesListFailure } from '../actions/companies';
import SearchClient from '../../api/SearchClient';

export function* companiesListRequestEvent({ payload = { query: {} } }) {
  const { network } = payload;
  const query = { ...payload.query };

  if (query.page) {
    query.page = parseInt(query.page, 10) - 1;
  }

  Object.keys(query).forEach((key) => {
    if (key.includes('organization.topics')) {
      if (!('topics' in query)) {
        query.topics = {};
      }

      query.topics[key.replace('organization.topics.', '')] = query[key];
      delete query[key];
    }
  });

  try {
    const result = yield call(SearchClient.findCompanies, {
      query: query.q,
      network,
      page: query.page,
      filters: query,
    });

    yield put(companiesListSuccess(result));
  } catch (e) {
    yield put(companiesListFailure());
  }
}

export default function* companiesRequest() {
  yield takeLatest(companiesListRequest().type, companiesListRequestEvent);
}
